export interface Feature {
  title: string;
  desc: string;
}

export const features: ReadonlyArray<Feature> = [
  {
    title: 'BRP Rules System',
    desc: "Built on Chaosium's legendary Basic Roleplaying — the same system behind Call of Cthulhu and RuneQuest. Familiar to thousands of TTRPG players worldwide.",
  },
  {
    title: 'Character Creation',
    desc: "Build your character from scratch or start with an Archetype, then customzie with skills, weapons, armor, and backstory using BRP's proven skill-based mechanics. BTW, you can print character sheets for tabletop play.",
  },
  {
    title: 'Party Play',
    desc: 'Gather your friends, or join a pick-up game, and tackle quests together. Coordination and strategy win the day.',
  },
  {
    title: 'AR Combat & Puzzles',
    desc: "While you can fight creatures, PCs, and NPCs, it's not all about combat.  Solve puzzles, riddles, and mysteries in complete narrative adventures.",
  },
  {
    title: 'Multi-media Encounters',
    desc: 'Video exposition, immersive soundscapes and virtual objects that bring the world alive around you.',
  },
  {
    title: 'Leaderboard',
    desc: 'Compete with adventurers worldwide. Climb the ranks and earn titles.',
  },

];
